export default "__VITE_ASSET__CJ6rKKtm__"